import React, { useCallback, useContext, useEffect, useState } from 'react';
import { LoadingContext } from './context/LoadingContext';
import { ToastContext } from './context/ToastContext';
import { Link } from 'react-router-dom';

const LIMIT_PER_PAGE = 10;

const BrandSideBar = () => {
    const [brandList, setBrandList] = useState([]);
    const [loading, setLoading] = useState(true);
    const { sendMessage } = useContext(ToastContext);
    const {
        startLoading,
        finishLoading,
    } = useContext(LoadingContext);
    const fetchBrands = useCallback(async (pageNumber = 0) => {
        try {
            startLoading();
            setLoading(true);
            const params = new URLSearchParams();
            params.append('page', pageNumber);
            params.append('limit', LIMIT_PER_PAGE);
            params.append('sortBy', 'PRODUCT_COUNT');
            params.append('order', 'DESC');
            const response = await fetch(new URL(`api/products/vendors/fullDetail?${params}`, process.env.APP_URL));
            const data = await response.json();
            setBrandList(data.vendors ?? []);
        } catch (e) {
            sendMessage(e.message, 'danger');
        } finally {
            finishLoading();
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchBrands();
    }, []);
    return (
        <div>
            <div
                style={{
                    minWidth: '200px',
                }}
                className={'d-flex flex-column border'}>
                <h3
                    className={'m-3 mb-0 p-0'}>Brands</h3>
                <hr />
                <div>
                    {loading && <div
                        className={'text-center'}>Loading...</div>}
                    {brandList.map((brand, index) => (
                        <div
                            key={`${brand.name}-${index}`}
                            className={'mx-3 my-2'}>
                            <Link
                                to={`/brands/${brand.name}`}
                                className={'default-link'}>
                                {brand.name}
                            </Link>
                        </div>
                    ))}
                    <div
                        className={'mx-3 mb-4 mt-2'}>
                        <Link
                            className={'default-link'}
                            to={'/brands'}>
                            <b>
                                View all brands
                            </b>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandSideBar;